import { useCallback, useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';

const useAccordionToggle = ({
  id,
  isOpenByDefault = true,
}: {
  id: string;
  isOpenByDefault?: boolean;
}): {
  isAccordionOpen: boolean;
  toggleAccordion: () => void;
} => {
  const key = `sl_${id}_isExpanded`;
  const [isAccordionOpenLocalStorage, setIsAccordionOpenLocalStorage] = useLocalStorage(
    key,
    isOpenByDefault,
  );
  const [isAccordionOpen, setAccordionOpen] = useState(isOpenByDefault);

  useEffect(() => {
    if (isAccordionOpenLocalStorage !== isAccordionOpen) {
      // keep the state var in sync with the local storage var
      setAccordionOpen(isAccordionOpenLocalStorage ?? isOpenByDefault);
    }
  }, [isAccordionOpen, isAccordionOpenLocalStorage, isOpenByDefault]);

  const toggleAccordion = useCallback(() => {
    setIsAccordionOpenLocalStorage(!isAccordionOpen);
  }, [setIsAccordionOpenLocalStorage, isAccordionOpen]);

  return { isAccordionOpen: !!isAccordionOpen, toggleAccordion };
};

export default useAccordionToggle;
